import { cn } from "@workspace/web-ui/lib/utils";
import { Circle } from "lucide-react";

interface PatientStatusBadgeProps {
    status: "Active" | "Inactive" | string;
    className?: string;
}

export const PatientStatusBadge = ({ status, className }: PatientStatusBadgeProps) => {
    return (
        <span
            className={cn(
                "inline-flex gap-1 items-center whitespace-nowrap h-[26px] px-3 py-2 rounded-full text-sm font-medium transition-colors w-fit",
                status === "Active" ? "bg-[#EBFBF1] text-[#14AD4D]" : "",
                status === "New" ? "bg-[#EBFBF1] text-[#14AD4D]" : "",
                status === "Inactive" ? "bg-[#FFF6E7] text-[#FFAB1F]" : "",
                status === "Not Paid" ? "bg-[#0404040D] text-[#464B55] border-[#0404041A]" : "",
                status === "Paid" ? "bg-[#F0F5FF] text-[#4272DD]" : "",
                status === "In Progress" ? "bg-[#F0F5FF] text-[#4272DD]" : "",
                status === "Closed" ? "bg-[#E6FAF2] text-[#00C781]" : "",
                status === "Pending Review" ? "bg-[#FFF5E6] text-[#FFA726]" : "",
                className
            )}
            role="status"
        >
            {status === "In Progress" && <Circle className="size-3" />}
            {status}
        </span>
    );
};

// For backward compatibility
export { PatientStatusBadge as PatientStatus }; 